<template>
	<div>
      <div class="sourceBatchNumberBox" v-for="(item, index) in skuBatchNoList" :key="index">
        <div class="skuTitle">库存批次号</div>
        <div class="batchNumberBox">
          <div v-if="item.showMore" class="batchNumerAreaBox">
            <div @click="toSelectSkuNumber(itema.batch_no,index)" v-for="(itema,indexA) in item.batch_nos" :key="indexA" :class="{active:batchNoSelect[index]==itema.batch_no}" class="batchNumberItem">
							<div style="font-size:15px;">{{ itema.batch_no }}</div>
							<div style="font-size:15px;">(
								<span v-if="showBatchCountObj[itema.batch_no]" style="color:#FB4747;font-size:15px;">{{showBatchCountObj[itema.batch_no]}}</span>
								<span v-else style="color:#FB4747;font-size:15px;">0</span>
								<template v-if="itema.is_weight==1" >
								/{{itema.number}}{{itema.unit}}
								</template>
								<template v-else >
								/{{itema.number}}{{itema.unit}}
								</template>
							)</div>
						</div>
          </div>
          <div v-if="!item.showMore" class="batchNumerAreaBox">
            <div v-if="indexA<4" @click="toSelectSkuNumber(itema.batch_no,index)" v-for="(itema,indexA) in item.batch_nos" :key="indexA" :class="{active:batchNoSelect[index]==itema.batch_no}" class="batchNumberItem">
							<div style="font-size:15px;">{{ itema.batch_no }}</div>
							<div style="font-size:15px;">(
								<span v-if="showBatchCountObj[itema.batch_no]" style="color:#FB4747;font-size:15px;">{{showBatchCountObj[itema.batch_no]}}</span>
								<span v-else style="color:#FB4747;font-size:15px;">0</span>
								<template v-if="itema.is_weight==1" >
								/{{itema.number}}{{itema.unit}}
								</template>
								<template v-else >
								/{{itema.number}}{{itema.unit}}
								</template>
							)</div>
						</div>
          </div>
          <div @click="toChangeShowMore(index,item)" v-if="item.batch_nos.length>4" class="operationBox">
            <span v-if="!item.showMore">展开</span><span v-if="item.showMore">收起</span>更多
              <Icon  v-if="!item.showMore" type="ios-arrow-down"/>
              <Icon  v-if="item.showMore" type="ios-arrow-up"/>
          </div>
        </div>
      </div>
	</div>
</template>

<script>
  import {querySkuBatchNo} from "@/api/traceSource/trace_source";
	export default {
		name: "batchNumberModel",
		props: {
			batchCountObj:{
				type:Object,
				default:{}
			}
		},
		data() {
			return {
				batchNoSelect:[],
        skuBatchNoList:[],
				showBatchCountObj:{}
			};
		},
		created(){
			this.formatNumberShow(this.batchCountObj)
		},
		methods: {
      // 判断是否展开
			toChangeShowMore(index,item){
				let that = this;
				if(item.showMore){
					item.showMore = false;
				}else{
					item.showMore = true;
				}
				that.$set(that.skuBatchNoList,index,item)
			},
      // 选中批次
			toSelectSkuNumber(item,index){
				let that = this;
        if(that.batchNoSelect[index]==item){
				  that.$set(that.batchNoSelect,index,"")
        }else{
				  that.$set(that.batchNoSelect,index,item)
        }
        this.$emit("callBackData",{
          batchNoSelect:this.batchNoSelect,
          skuBatchNoList:this.skuBatchNoList
        })
			},
      // 查询SKU或者SPU对应的批次
      querySkuBatchNos(groupSkuId,batch_no) {
				this.batchNoSelect = [];
				this.skuBatchNoList = [];
        if (!groupSkuId)
          return;
        querySkuBatchNo({parent_sku_id: groupSkuId}).then(data => {
          if (data.data.code === 1200) {
						if(data.data.data&&data.data.data.length){
							data.data.data.forEach(item=>{
								if(item.is_weight==1){
									// item.number =  parseFloat( Number((item.sumWeight/500).toFixed(2)))
									item.number =  parseFloat( Number(item.sumWeight.toFixed(2)))
								}
							})
							this.skuBatchNoList = [{skuId:data.data.data[0].sku_id, skuName:data.data.data[0].title, batch_nos:data.data.data}];
							console.log("库存列表",this.skuBatchNoList)
              if(batch_no){
								this.batchNoSelect.push(batch_no);
							}else{
								// 顺序不可修改
								this.batchNoSelect.push(data.data.data[0].batch_no);
							}
							this.toCountWhatBatchCanSelect();
							this.$emit("callBackData",{
								batchNoSelect:this.batchNoSelect,
								skuBatchNoList:this.skuBatchNoList
							})
						}
          }
        }).catch(err => {
          this.$Message.error(err);
        })
			},
			// 格式化数据展示
			formatNumberShow(newValue){
				if(newValue){
					this.showBatchCountObj = {};
					for(let k in newValue){
						this.$set(this.showBatchCountObj,k,newValue[k])
					}
				}
				// 计算当前
				this.toCountWhatBatchCanSelect();
			},
			// 计算应该选中哪一个批次
			toCountWhatBatchCanSelect(){
				let that = this;
				let realData = that.skuBatchNoList[0];
				let canUseList = [];
				if(realData&&realData.batch_nos&&realData.batch_nos.length){
					realData.batch_nos.forEach((item,index)=>{
						let useNumber = this.showBatchCountObj[item.batch_no]||0
						let lastNumber = item.number - useNumber;
						if(lastNumber>0){
							canUseList.push(item.batch_no);
						}
					})
				}
				if(canUseList.length){
					that.toSelectSkuNumber(canUseList[0],0)
				}
			}
		},
		mounted() {
		},
		destroyed() {
		},
		watch:{
			batchCountObj(newValue,oldValue){
				this.formatNumberShow(newValue)
			}
		}
	}
</script>

<style scoped lang="less">
.sourceBatchNumberBox{
		.skuTitle{
			height: 35px;
		}
		.batchNumberBox{
			width: 100%;
			position: relative;
			.batchNumerAreaBox{
				width: 100%;
				display: flex;
				flex-wrap: wrap;
			}
			.batchNumberItem{
				width: 20%;
				height: 50px;
				overflow: hidden;
				font-size: 16px;
				padding: 0 10px;
				margin-right: 10px;
				margin-bottom: 10px;
				white-space: nowrap;
				display: flex;
				justify-content: center;
				flex-direction: column;
				text-overflow: ellipsis;
				box-sizing: border-box;
				background-color: #ffffff;
				&.active{
					color: #FFFFFF;
					border-radius: 2px;
					background: #6699CC;
				}
			}
			.operationBox{
				top:0;
				right:0;
				width: 10%;
				height: 50px;
				display: flex;
				color: #2D8cF0;
				position: absolute;
				align-items: center;
				justify-content: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/batchNumberModel/batchNumberModel.vue